export default __webpack_public_path__ + "static/smoothie_product-44a492fdbdc2f31487064d6f36e5b3db.jpg";